import { useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useSelector } from "react-redux";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import YourPost from "../../../../Common/Label/YourPost";
import PostReportMenu from "../../../../Common/Label/PostReportMenu";
import { navigateToNextTab } from "../../../../Common/FewCommonMethods";
import DisplayFileExtensionWise from "../../../../Common/FilesRelevent/DisplayFileExtensionWise";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";


export default function AllBuyProducts({ activeTab }) {
  const path = "Assets/scss/FindWork.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);


  const { state, setPageNumber } = useAllFilterBaseContext();

  const getallrental = useSelector(
    ({ rental: { getfilterdrental } }) => getfilterdrental
  );
  const getrentallist = getallrental?.response || [];

  function truncateDescription(description = "", wordLimit = 5) {
    if (typeof description !== "string") {
      console.error("Invalid input: description must be a string.");
      return "";
    }

    const words = description.split(" ");
    if (words.length <= wordLimit) {
      return description;
    }
    return words.slice(0, wordLimit).join(" ") + "...";
  }

  return (
    <div className="col-lg-9 col-md-8 filter-right">
      <h2>All Turn Assets to Income (TAI)</h2>
      {Array.isArray(getrentallist) && getrentallist.length > 0 ? (
        <div className="row packaged-row">
          {Array.isArray(getrentallist) &&
            getrentallist?.map((item, index) => (
              <div className="col-lg-4 col-md-6 col-6">
                <div className="d-flex post-sold">
                  <YourPost item={item} />
                </div>
                <div
                  className="packaged-img"
                  style={{ position: "relative" }}
                  onClick={() =>
                    navigateToNextTab(`rentproductdetails/${item?.id}`)
                  }
                >
                  <PostReportMenu item={item} masterType={8} />
                  <DisplayFileExtensionWise item={{ file: Array.isArray(item?.files) && item?.files[0]?.file }} className="w-100" alt="" />
                  <h6>{item?.title}</h6>
                  <CustomReactQuillDescription
                    value={truncateDescription(item?.description)}
                  />
                </div>
              </div>
            ))}
          {getallrental && (
            <CommonPagination
              totalitemcounts={
                activeTab == "allpost"
                  ? getallrental?.count?.count
                  : activeTab == "recentview"
                    ? getallrental?.count?.viewed_count
                    : activeTab == "savepost"
                      ? getallrental?.count?.wishlist_count
                      : getallrental?.count?.count
              }
              size={15}
              pageNumber={state?.pageNumber}
              setPageNumber={setPageNumber}
            />
          )}
        </div>
      ) : (
        <PostNotFound title={"Turn Assets to Income (TAI) Not Found..."} />
      )}
    </div>
  );
}
